// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"vE-z","smallCardRow":"wE-z","largeCardRow":"xE-z","productSearchRow":"yE-z","curatedRow":"zE-z"};